module.exports = __webpack_public_path__ + "img/newicon3.dddc43ff.svg";